import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'TRIX',
  version: 2,
  label: 'TRIX',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 4,
  order: 80,
  inputs: [period('timeperiod', 30)],
  outputs: [line('trix', 'TRIX', COLOR.blue)],
  talib: { functions: ['TRIX'], expr: 'TRIX(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => 3 * (timeperiod - 1) + 1,
}
export default def
